import { AnalyticsVersion } from 'types/analytics'

type DoubleBadgeProps = {
  version: AnalyticsVersion
  feeTier: string
}

export default function DoubleBadge({ version, feeTier }: DoubleBadgeProps) {
  return (
    <div className="flex gap-0.5 items-center min-h-10">
      <div className="rounded-xl rounded-r-none bg-kodiak-brand-secondary py-1 px-1.5 md:px-2.5 min-w-10 md:min-w-12 font-medium text-sm text-center">
        {version}
      </div>
      <div className="rounded-xl rounded-l-none bg-kodiak-brand-secondary py-1 px-1.5 md:px-2.5 font-medium text-sm">
        {feeTier}
      </div>
    </div>
  )
}
